import React from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { Card } from 'src/@vymo/ui/blocks';
import { SummaryCardProps } from './types';
import styles from './index.module.scss';

function SummaryCard({ label, value, variant, icon }: SummaryCardProps) {
  return (
    <Card
      classNames={`${styles.myPDD__summaryCard} ${
        variant === 'critical' ? styles.myPDD__critical : styles.myPDD__pending
      }`}
    >
      <span className={styles.myPDD__summaryIcon}>{icon}</span>
      <div className={styles.myPDD__summaryContent}>
        <Text type="subText" classNames={styles.myPDD__summaryLabel}>
          {label}
        </Text>
        <Text bold classNames={styles.myPDD__summaryValue}>
          {value}
        </Text>
      </div>
    </Card>
  );
}

export default SummaryCard;
